<template>
  <div>
    <back />
    <div class="det">
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="订单编号:">
                  <div> {{ ruleForm.orderCode }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单类型:">
                  <div>自提</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单状态:">
                  <div v-if="ruleForm.orderStatus == -1">已取消</div>
                  <div v-if="ruleForm.orderStatus == 0" style="color: red;">待支付</div>
                  <!-- <div v-if="ruleForm.orderStatus == 1" style="color: red;">待发货</div> -->
                  <!-- <div v-if="ruleForm.orderStatus == 2">已发货</div> -->
                  <div v-if="ruleForm.orderStatus == 3" style="color: red;">待自提</div>
                  <div v-if="ruleForm.orderStatus == 4">已完成</div>
                  <div v-if="ruleForm.orderStatus == 5">已取消</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="售后状态:">
                  <div v-if="ruleForm.aftersaleStatus == 1" style="color: red;">售后中</div>
                  <div v-if="ruleForm.aftersaleStatus == 2">售后成功</div>
                  <div v-if="ruleForm.aftersaleStatus == 3">售后关闭</div>
                  <div v-if="ruleForm.aftersaleStatus == 0">--</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="订单金额:">
                  <div>{{ ruleForm.orderAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="优惠金额:">
                  <div>{{ ruleForm.discountAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <!-- <el-form-item label="打包费用:">
                  <div>{{ ruleForm.packAmount }} 元</div>
                </el-form-item> -->
                <el-form-item label="下单时间:">
                  <div>{{ ruleForm.orderTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款时间:">
                  <div>{{ ruleForm.paymentTime || '--' }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="预计到店时间:">
                  <div>{{ ruleForm.shopEstimatedTime || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="完成时间:" v-if="ruleForm.orderStatus == 4">
                  <div>{{ ruleForm.completionTime }}</div>
                </el-form-item>
                <el-form-item label="取消时间:" v-if="ruleForm.orderStatus == 5">
                  <div>{{ ruleForm.cancelTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="申请售后时间:" v-if="ruleForm.aftersaleStatus >= 1 && ruleForm.orderStatus == 4">
                  <div>{{ ruleForm.afterSalesTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="售后处理时间:" v-if="ruleForm.aftersaleStatus == 2">
                  <div>{{ ruleForm.completionAfterSalesTime }}</div>
                </el-form-item>
                <el-form-item label="取消售后时间:" v-if="ruleForm.aftersaleStatus == 3">
                  <div>{{ ruleForm.cancelAfterSalesTime }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row v-if="ruleForm.aftersaleStatus == 2 && ruleForm.orderStatus == 5">
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="退款时间:">
                  <div>{{ ruleForm.refundTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备注：" label-width="85px">
                <div>{{ ruleForm.buyerNotes || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="用户编号：">
                  <div>{{ ruleForm.userCode }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="用户昵称：">
                  <div>{{ ruleForm.userName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <div class="top">
        <h4 class="title">商品信息：</h4>
        <!-- 表格 -->
        <div class="g_table tableBox">
          <el-table :data="tableData">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="" label="商品图片" show-overflow-tooltip min-width="100" align="center">
              <template slot-scope="scope">
                <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
                <div style="color: #069BBC;cursor: pointer;" @click="handleCommand(scope.row.picUrl)">查看图片</div>
              </template>
            </el-table-column>
            <el-table-column prop="barCode" label="商品条形码" show-overflow-tooltip min-width="150" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" show-overflow-tooltip min-width="150" align="center">
            </el-table-column>
            <el-table-column prop="specs" label="商品规格" show-overflow-tooltip min-width="100" align="center">
            </el-table-column>
            <el-table-column prop="categoryName" label="商品类目" show-overflow-tooltip min-width="120" align="center">
            </el-table-column>
            <el-table-column prop="brand" label="商品品牌" show-overflow-tooltip min-width="120" align="center">
            </el-table-column>
            <el-table-column prop="productPrice" label="售价(元)" show-overflow-tooltip min-width="110" align="center">
            </el-table-column>
            <el-table-column prop="productCount" label="购买数量" show-overflow-tooltip min-width="100" align="center"
              fixed="right">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="bottom">
        <div>商品总价：￥{{ Number(ruleForm.productTotal).toFixed(2) }}</div>
        <!-- <div>运费：￥{{ Number(ruleForm.freight).toFixed(2) }}</div> -->
        <!-- <div>打包费：￥{{ Number(ruleForm.packAmount).toFixed(2) }}</div> -->
        <div>优惠：￥{{ Number(ruleForm.discountAmount).toFixed(2) }}</div>
        <div>应付：<span style="color: red;font-weight: bolder;font-size: 20px;">
            ￥{{ Number(ruleForm.payAmount).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},//订单信息
      tableData: [],//商品内容
      srcList: null, //大图预览
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    // 请求信息
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.productOrderInfo, {
        params: {
          orderId: this.$route.query.orderId,//订单id
          storeId: this.$store.state.userInfo.bizId,//门店id
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.tableData = result.selectOnlineOrdersProductVoList || []//商品内容
        }
      }).catch(() => {
        this.loading = false;
      })

    },
    // 查看图片
    handleCommand(imageUrl) {
      this.srcList = null
      if (imageUrl) {
        this.srcList = imageUrl;
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传商品图片!");
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }



  }

  .bottom {
    display: flex;
    align-items: flex-end;
    color: #505554;
    font-weight: bold;
    justify-content: flex-end;
    padding: 10px 0;

    div {
      margin-right: 20px;
    }
  }

}
</style>